export const CPFValidator = (value: string | undefined) => {
  if (value === undefined) return false

  const CPF = value.replace(/\D/g, '')

  if (CPF.length !== 11) return false

  if (/^(\d)\1*$/.test(CPF)) return false

  let sum = 0
  let remainder

  for (let i = 1; i <= 9; i++) {
    sum += parseInt(CPF.substring(i - 1, i)) * (11 - i)
  }
  remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(CPF.substring(9, 10))) return false

  sum = 0
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(CPF.substring(i - 1, i)) * (12 - i)
  }
  remainder = (sum * 10) % 11
  if (remainder === 10 || remainder === 11) remainder = 0
  if (remainder !== parseInt(CPF.substring(10, 11))) return false

  return true
}

export const CEPValidator = (value: string | undefined) => {
  if (value === undefined) return false

  const CEP = value.replace(/\D/g, '')

  if (CEP.length === 0) return false

  if (CEP.length !== 8) return true

  return false
}

export const emailValidator = (value: string | undefined) => {
  if (value === undefined) return false

  if (value.length === 0) return false

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  return !emailRegex.test(value)
}
